import React, { useEffect, useState } from "react";
import { Cookies } from "../../../../index.js";
import { alert_error, alert_success } from "../../../../AppContext";
import axios from 'axios';
import { Helmet } from "react-helmet";
import Post_content from '../../../../community/content/Blog_posts.jsx';

const AboutUs = ({ datajoptiktok, base64Image_1, handleImageChange_1 }) => {
    const [show_example, setshow_example] = useState(false);
    const [show_error, setshow_error] = useState(false);
    return (
        <>
            <div className="mb-1">
                <h2 className="text-lg font-bold mb-0">Bước 1: Mở tele</h2>
                <div className="text-center">
                    <a href={datajoptiktok.url_jop}
                        target="_blank" >Ấn vô link sau để mở tele: {datajoptiktok.tele_username} </a>
                </div>
            </div>
            <div className="mb-1">
                <h2 className="text-lg font-bold mb-0">Bước 2: add danh bạ</h2>
                <div className="text-center">
                    <li>add vô danh bạ bạn trên tele ko làm ng ta biết</li>
                </div>
            </div>
            <div className="mb-1">
                <h2 className="text-lg font-bold mb-0">Bước 3: mời vô nhóm</h2>
                <div className="text-center">
                    <a href={datajoptiktok.url_box}
                        target="_blank" >Mời người ta vô nhóm: {datajoptiktok.box_username} </a>
                </div>
            </div>
            <div className="mb-1">
                <h2 className="text-lg font-bold mb-0">Xem hướng dẫn</h2>
                <div className="text-center">
                    <div
                        className="button inline-block px-2 py-1 bg-blue-500 text-white font-semibold rounded-lg hover:bg-blue-600 transition duration-300"
                        onClick={() => setshow_example(!show_example)}
                    >
                        Xem hình ảnh mẫu ở đây
                    </div>
                    {show_example && (
                        <div className="flex text-center">
                            <div className="mx-auto" >
                                <Post_content mode={'telegram'} show_adsense={'NO'} channel={'dangbaiok'} id_post={'25144'} />
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <div className="mb-1">
                <div className="text-center">
                    <div
                        className="button inline-block px-2 py-1 bg-blue-500 text-white font-semibold rounded-lg hover:bg-blue-600 transition duration-300"
                        onClick={() => setshow_error(!show_error)}
                    >
                        Báo lỗi
                    </div>
                    {show_error && (
                        <>
                            <h2 className="text-lg font-bold mb-1">Gửi ảnh lỗi</h2>
                            <ul className="list-disc pl-6">
                                <li>
                                    <div className="text-center">
                                        Gửi ảnh lỗi để vượt links
                                        <input
                                            type="file"
                                            accept="image/*"
                                            onChange={handleImageChange_1}
                                            className="rounded"
                                        />
                                        {base64Image_1 && (
                                            <div className="">
                                                <img src={base64Image_1} alt="Selected" className="mx-auto w-44 rounded mr-4" />
                                            </div>
                                        )}
                                    </div>

                                </li>

                                <li className="text-sm">Lưu ý: Các trường hợp dc duyệt nhóm lỗi, hoặc nick tele lỗi, hoặc ko mời dc</li>
                            </ul>
                        </>
                    )}
                </div>
            </div>
        </>
    );
}

export default AboutUs;
